export function onEnterKeyPress(event: any, callback: () => void) {
  const enterKeyCode = 13;
  const key = event.which || event.keyCode;
  if (key === enterKeyCode) {
    callback();
  }
}
